/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface ArchiveSitesResponse
 */
export interface ArchiveSitesResponse {
  /**
   *
   * @type {number}
   * @memberof ArchiveSitesResponse
   */
  status?: number
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof ArchiveSitesResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function ArchiveSitesResponseFromJSON(json: any): ArchiveSitesResponse {
  return ArchiveSitesResponseFromJSONTyped(json, false)
}

export function ArchiveSitesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArchiveSitesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function ArchiveSitesResponseToJSON(value?: ArchiveSitesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
